import { globalVariables } from "helper/globalVariables";
import CountCard from "../CountCard";

const TrialAnalytics = ({TrialAnalyticsData}) => {
  return (
    <div className="grid md:grid-cols-3 gap-4 mt-[20px]">
      <CountCard heading={globalVariables.noOfTrialEntered} count={TrialAnalyticsData?.noOfTrialEarned} />
      <CountCard heading={globalVariables.noOfQualification} count={TrialAnalyticsData?.noOfQualification} />
      <CountCard heading={globalVariables.noOfNonQualification} count={TrialAnalyticsData?.noOfNonQualification} />
    </div>
  );
};
export default TrialAnalytics;
